// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"6704":"2de76c69","7975":"ba777987"}[chunkId] + ".css";
};